import React from "react";
import { Field } from "react-final-form";

import { TextFieldAdapter } from "@soqs/common";
const FraudPhoneFieldComponent = (props) => {
  let { variant, required, name, label } = props;

  if (!variant) {
    variant = "mobile";
  }

  if (required === undefined) {
    required = false;
  }
  const isValid = (tel) => {
    const re = /^[0-9]{10}$/;
    return (tel || !required) &&
      (re.test(tel) || (!required && (tel === undefined || tel?.length === 0)))
      ? undefined
      : "Enter a valid contact cell number";
  };

  const stripSpaces = (value) => {
    return value && value.replace(/ /g, "");
  };
  return (
    <Field
      name={name}
      validate={isValid}
      label={label}
      autoComplete="tel-national"
      required={required}
      component={TextFieldAdapter}
      subscription={{ touched: true, value: true, error: true }}
      parse={stripSpaces}
      fullWidth
      inputProps={{ maxLength: 10 }}
    />
  );
};

export default FraudPhoneFieldComponent;
